import {
	LuIcon,
	Menu,
	type MenuClickTriggerProps,
	type MenuMultiSelectGroupProps,
	type MenuRootProps,
	type MenuVariantProps,
} from "@overmap-ai/blocks"
import { memo, type ReactElement } from "react"

import { ISSUE_ACTIVITY_HISTORY_ITEM_TYPES } from "../../constants"
import { IssueTimelineItemType } from "../../enums/issues"
import { issueTimelineItemTypeData } from "../../mappings/issues"
import { MultiSelectItemTemplate, SelectAllItemTemplate } from "../MenuGroups/constants"

interface IssueActivityHistoryItemTypeMultiSelectDropdownProps
	extends
		MenuRootProps,
		MenuMultiSelectGroupProps<IssueTimelineItemType>,
		MenuVariantProps,
		Omit<MenuClickTriggerProps, "children" | "ref"> {
	children: ReactElement
}

export const IssueActivityHistoryItemTypeMultiSelectDropdown =
	memo<IssueActivityHistoryItemTypeMultiSelectDropdownProps>((props) => {
		const { children, disabled, variant, size, accentColor, values, onValuesChange, defaultValues, ...rest } = props

		return (
			<Menu.Root {...rest}>
				<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
				<Menu.Content variant={variant} size={size} accentColor={accentColor}>
					<Menu.MultiSelectGroup<IssueTimelineItemType>
						defaultValues={defaultValues}
						values={values}
						onValuesChange={onValuesChange}
					>
						<SelectAllItemTemplate>Select all</SelectAllItemTemplate>
						{ISSUE_ACTIVITY_HISTORY_ITEM_TYPES.map((type) => {
							const { icon, label } = issueTimelineItemTypeData[type]

							return (
								<MultiSelectItemTemplate<IssueTimelineItemType> key={type} value={type}>
									<LuIcon icon={icon} />
									{label}
								</MultiSelectItemTemplate>
							)
						})}
					</Menu.MultiSelectGroup>
				</Menu.Content>
			</Menu.Root>
		)
	})
IssueActivityHistoryItemTypeMultiSelectDropdown.displayName = "IssueActivityHistoryItemTypeMultiSelectDropdown"
